module.exports = __webpack_public_path__ + "img/gvoz-1920.5110a8a5.svg";